import { Group } from '@/router/group.model';
import { customerCenter } from '@/router/routes/performance';

const routes = [customerCenter];

const myCustomersGroup = new Group('Members', 'members', routes, {
  superRoot: false,
  icon: 'customer-center',
  description:
    'List of all of your members, their transactions, rewards and redemptions.'
});

export { myCustomersGroup };
export default myCustomersGroup;
